import React, { } from 'react';
import {
    Typography,
    Button
} from '@material-ui/core'

import ReactHtmlParser from 'react-html-parser'

import Label from './Label/Label'

const SelectQuestion = (props) => {


    const img = props.img ? 
    (<div style={{
        width: "100%"

    }}>
        <picture>
            <img src={props.img} alt="" style={{
                width: "100%",
                height: "auto",
                margin: "1rem 0"
            }} />
        </picture>
    </div>) : 
    null 

    return (
        <div
            style={{
                minHeight: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                // alignItems: "center",
                padding: "1rem 1rem 0 1rem"

            }}>
            <Typography>
                <span>{props.id}.&nbsp;&nbsp;</span>
                <span>{props.children}</span>
            </Typography>
            
            {img}
            <div>
                {props.options}

            </div>
            <div className="buttons-container">
                <Button
                    variant="contained"
                    color="primary"
                    onClick={props.buttonClick}
                    fullWidth
                >下一題啦，嫩！</Button>
            </div>
        </div>

    )

}

export default SelectQuestion;